import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';

import { LoadingScreen } from 'components';
import * as views from './views';
import { selectors, TRAINEE, TRAINER, ADMIN, CLIENT } from 'state';
import Cookies from 'js-cookie';
// Dispatch ownership before either session container can mount its runtime.
import SessionEngineRoute from './views/NativeSession/SessionEngineRoute';
import { ENVIRONMENT } from 'settings';

const OpenSourceCompliance = React.lazy(
  () => import('./views/OpenSourceCompliance')
);

const Routes: React.FC = () => {
  const token = useSelector(selectors.token);
  const userType = useSelector(selectors.userType);
  const refresh_ = Cookies.get(`pm_${ENVIRONMENT}_refresh`);
  const [refreshTokenOld, setRefreshTokenOld] = useState(refresh_);

  // useEffect(() => {
  //TODO: This thing was a poor man's cross-tab (cross subdomain) communication
  // that was used in conjuncture with portal.traderion.com (MFA) that is unused at the moment
  // When PM will need MFA (login though portal.traderion.com) we'll need to
  // implement an (not makeshift) event message communication using iFrames
  // https://stackoverflow.com/questions/27234528/cross-domain-cross-tab-communication-between-co-operating-pages
  // reason: if user is already logged into PM in a tab and for whatever reason decides to go to portal
  // and login (to PM) with a different user, make sure the old tab doesn't remain stale with the old user.

  // const intervalId = setInterval(() => {
  //   const newToken = Cookies.get(`pm_${ENVIRONMENT}_refresh`);
  //   if (refreshTokenOld !== newToken) {
  //     console.log('Refresh token changed. Navigating to current user.');
  //     window.location.href = '/dashboard'; // Full reload
  //   }
  // }, 3000);

  // }
  // return () => clearInterval(intervalId);
  // }, []);

  // useEffect(() => {
  //   if (token) {
  //     console.log('triggered refresh? -------------------');
  //     console.log('state refresh token: ', refresh);
  //     console.log('cookie refresh token: ', Cookies.get('refresh'));
  //     dispatch(refreshToken({ refresh: Cookies.get('refresh') }));
  //   }
  // }, [dispatch]);

  // useInterval(() => {
  //   if (token) {
  //     const tokenExpiration = Number(
  //       Cookies.get(`pm_${ENVIRONMENT}_token_exp`)
  //     );
  //     const now = Date.now() / 1000;
  //     const left = tokenExpiration - now;
  //     if (left < 60) {
  //       dispatch(
  //         refreshToken({ refresh: Cookies.get(`pm_${ENVIRONMENT}_refresh`) })
  //       );
  //     }
  //   }
  // }, 1000 * 30);

  const PublicRoute = (path: string, view: React.FC) => (
    <Route path={path} key={path}>
      {view({})}
    </Route>
  );

  const OpenSourceRoute = (
    <Route path="/open-source" key="/open-source">
      <React.Suspense fallback={<LoadingScreen />}>
        <OpenSourceCompliance />
      </React.Suspense>
    </Route>
  );

  const publicRoutes = [
    OpenSourceRoute,
    PublicRoute('/bond-calculator', views.BondCalculator),
  ];
  // console.log('token before route decision: ', token);
  if (!token)
    return (
      <Switch>
        {publicRoutes}

        <Route path={`/auth`}>
          <views.Auth />
        </Route>
        <Redirect to={`/auth/login`} />
      </Switch>
    );
  // console.log('after !token if statement');

  return (
    <Switch>
      {publicRoutes}

      <Route path={`/dashboard`}>
        {userType === TRAINEE && <views.TraineeDashboard />}
        {userType === TRAINER && <views.TrainerDashboard />}
        {userType === ADMIN && <views.AdminDashboard />}
        {/* CLIENT observers get the Activity Dashboard and ONLY that. */}
        {userType === CLIENT && <views.ClientDashboard />}
      </Route>
      <Route path={`/session/:id`}>
        {userType === TRAINEE && <SessionEngineRoute legacy={<views.TraineeSession />} />}
        {(userType === TRAINER || userType === ADMIN) && <SessionEngineRoute legacy={<views.TrainerSession />} />}
        {/* No session view for CLIENT: explicit redirect (the && pattern would
            otherwise render an empty page for an unmapped role). */}
        {userType === CLIENT && <Redirect to={`/dashboard`} />}
      </Route>
      <Redirect to={`/dashboard`} />
    </Switch>
  );
};

export default Routes;
